import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-header" }

import { h, computed } from "vue";
import CustomText from "@/components/common/CustomText.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileHeader',
  props: {
    introduction: {}
  },
  setup(__props: any) {

const props = __props;

const introductionContent = computed(() => {
  return props.introduction;
});

// Custom components for minimalist styling
const customTextComponents = {
  block: {
    normal: (_: unknown, { slots }: { slots: { default?: () => unknown } }) => {
      return h(
        "p",
        {
          class:
            "text-base text-stone-600 dark:text-stone-400 leading-relaxed mb-3",
        },
        slots.default?.()
      );
    },
    h1: (_: unknown, { slots }: { slots: { default?: () => unknown } }) => {
      return h(
        "h1",
        {
          class:
            "font-display text-4xl lg:text-5xl font-bold text-stone-900 dark:text-stone-100 tracking-tight leading-tighter mb-2",
        },
        slots.default?.()
      );
    },
    h2: (_: unknown, { slots }: { slots: { default?: () => unknown } }) => {
      return h(
        "h2",
        {
          class: "text-xl font-medium text-stone-700 dark:text-stone-300 mb-4",
        },
        slots.default?.()
      );
    },
    h4: (_: unknown, { slots }: { slots: { default?: () => unknown } }) => {
      return h(
        "h4",
        {
          class:
            "text-sm uppercase tracking-widest text-stone-500 dark:text-stone-500 font-medium mb-3",
        },
        slots.default?.()
      );
    },
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomText, {
      value: introductionContent.value,
      components: customTextComponents
    }, null, 8, ["value"])
  ]))
}
}

})